export type FindScaleForDimensions = {
  containerSize: { width: number; height: number };
  elementSize: { width: number; height: number };
  defaultScale: number;
};

/**
 * This method finds the lowest scale that fits the dimensions of the container
 */
export const findScaleForDimensions = ({ defaultScale, elementSize, containerSize }: FindScaleForDimensions) => {
  const { height: availableHeight, width: availableWidth } = containerSize;
  const { height: elementHeight, width: elementWidth } = elementSize;

  const isPortrait = elementHeight > elementWidth;

  let scaleToSet = defaultScale;
  if (isPortrait) {
    if (elementHeight > availableHeight) {
      scaleToSet = Math.min(defaultScale, availableHeight / elementHeight);
    }
    const newWidth = elementWidth * scaleToSet;
    if (newWidth > availableWidth) {
      return Math.min(defaultScale, availableWidth / elementWidth);
    }
  } else if (!isPortrait) {
    if (elementWidth > availableWidth) {
      scaleToSet = Math.min(defaultScale, availableWidth / elementWidth);
    }
    const newHeight = elementHeight * scaleToSet;
    if (newHeight > availableHeight) {
      return Math.min(defaultScale, availableHeight / elementHeight);
    }
  }

  return scaleToSet;
};
